import { useUrlCoupon } from 'mod/coupon/useUrlCoupon';
import dynamic from 'next/dynamic';
import { IFixedRegisterProps } from 'mod/login/FixedRegister/interface';

const FixedCoupon = dynamic(() => import('@app/common/FixedCoupon'), { ssr: false });
const FixedRegister = dynamic(() => import('@app/common/FixedRegister'), { ssr: false });

export type IOpeningPopupProps = {
    fixedRegisterActive?: boolean;
    fixedRegisterProps?: IFixedRegisterProps;
}

export const OpeningPopup = (props: IOpeningPopupProps) => {
    const { fixedRegisterActive = true, fixedRegisterProps } = props;
    const { coupon, isLogin, couponLoaded } = useUrlCoupon();
    if (!couponLoaded) {
        return null;
    }
    if (coupon) {
        return <FixedCoupon coupon={coupon} isLogin={isLogin}/>
    }

    return fixedRegisterActive ? <FixedRegister {...fixedRegisterProps}/> : null;
};
